import listsoal from '../../../views/Kurikulum/Elearning/listsoal.view';

export default listsoal;